module.exports = "/images/vendor/desiigner-svg/svg/specials/diversity.svg?b3264a55b308c91267fed35388103f29";